import queryString from 'query-string';

import {CustomEventDefinition} from 'common/report/util/saved-entities/types';
import {FetchOptions} from 'common/util/shared-client';

import {appApiUrl} from '../utils';
import {BaseClient, QueryOptions} from '../utils/base-client';

export class CustomEventsClient extends BaseClient<CustomEventDefinition[]> {
  buildEndpoint({projectId, workspaceId, customEventId}) {
    let endpoint = appApiUrl(`custom_events/`, {projectId, workspaceId});
    if (customEventId) {
      endpoint += `${customEventId}`;
    }

    return endpoint;
  }

  public getFetchOptions(params, queryOpts: QueryOptions): FetchOptions {
    return super.getFetchOptions(params, {...queryOpts, contentType: `application/x-www-form-urlencoded`});
  }

  buildRequestBody({customEvent}) {
    return customEvent
      ? queryString.stringify({name: customEvent.name, alternatives: JSON.stringify(customEvent.alternatives)})
      : null;
  }

  processResponse(response) {
    if (response.error) {
      throw new Error(response.error);
    }
    const {custom_events: customEvents, custom_event: customEvent} = response;
    return Array.isArray(customEvents)
      ? customEvents.map((customEvent) => ({...customEvent, custom: true}))
      : {...customEvent, custom: true};
  }
}

export const customEventsClient = new CustomEventsClient();
